import { render, staticRenderFns } from "./role-management.vue?vue&type=template&id=e245ed24&scoped=true&"
import script from "./role-management.vue?vue&type=script&lang=js&"
export * from "./role-management.vue?vue&type=script&lang=js&"
import style0 from "./role-management.vue?vue&type=style&index=0&id=e245ed24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e245ed24",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e245ed24')) {
      api.createRecord('e245ed24', component.options)
    } else {
      api.reload('e245ed24', component.options)
    }
    module.hot.accept("./role-management.vue?vue&type=template&id=e245ed24&scoped=true&", function () {
      api.rerender('e245ed24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sms-system-management/role-management.vue"
export default component.exports